import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
  fullWidth?: boolean;
}
export function Section({
  children,
  className = '',
  dark = false,
  fullWidth = false
}: SectionProps) {
  return <section className={`relative py-16 md:py-24 ${dark ? 'bg-black text-white' : 'bg-white text-black'} ${className}`} data-id="element-161">
      <div className={`mx-auto px-4 md:px-8 ${fullWidth ? 'w-full max-w-none' : 'max-w-4xl'}`} data-id="element-162">
        {children}
      </div>
    </section>;
}